import { TAG } from "../constants";
import { Charge } from "../types";
import { patientApi } from "./patientApi";

export const chargesApi = patientApi.injectEndpoints({
  endpoints: (builder) => ({
    getCharges: builder.query<Charge[], void>({
      query: () => ({
        method: "GET",
        url: `/api/patient/charges`,
      }),
      providesTags: [TAG.CHARGES],
    }),
    getChargeByInvoice: builder.query<Charge, string>({
      query: (invoice: string) => ({
        method: "GET",
        url: `/api/patient/charges/${invoice}`,
      }),
      providesTags: [TAG.CHARGES],
    }),
  }),
});

export const { useGetChargesQuery, useGetChargeByInvoiceQuery } = chargesApi;
